import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

// Cuadro de credenciales: primero se REVISA lo que el panel entendió (sin contraseñas) y luego se GUARDA.
export function usePreviewCredentials(projectId) {
  return useMutation({
    mutationFn: async (text) => (await apiClient.post(`/projects/${projectId}/credentials/preview`, { text })).data,
  });
}

export function useSaveCredentials(projectId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ text, allowChanges }) =>
      (await apiClient.post(`/projects/${projectId}/credentials/save`, { text, allow_changes: !!allowChanges })).data,
    onSettled: () => queryClient.invalidateQueries({ queryKey: ["servers", projectId] }),
  });
}

// «Ver credenciales»: la ficha completa (con contraseña) solo se pide al hacer clic y no se guarda en caché.
export async function fetchServerCredentials(projectId, serverId) {
  return (await apiClient.get(`/projects/${projectId}/servers/${serverId}/credentials`)).data;
}
